export default "__VITE_ASSET__8bb228e4__"